
<div class="component-modal-header">
  <span class="modal-title">Select Workers</span>

  <button type="button" class="close" aria-label="Close" (click)="closeModal()"><span class="pi pi-times"></span></button>
</div>

<div class="modal-body">
  <div class="mb-2 animated fadeIn">
    <div class="row">
      <div class="col-md-12">
        <div class="filter-flex-row">
          <div>
            <label>First Name:</label>
            <text-filter-box (onFilterTextChanged)="onFilterTextChanged($event, 'firstName')"></text-filter-box>
          </div>
          <div>
            <label>Last Name:</label>
            <text-filter-box (onFilterTextChanged)="onFilterTextChanged($event, 'lastName')"></text-filter-box>
          </div>
          <div>
            <label>Company Name:</label>
            <text-filter-box (onFilterTextChanged)="onFilterTextChanged($event, 'company')"></text-filter-box>
          </div>
          <div *ngIf="isFilterLoading" class="small-spinner">
            <p-progressSpinner [strokeWidth]="5"></p-progressSpinner>
          </div>
        </div>
        <br>
      </div>
    </div>
    <div class="row">
      <div class="col-md-12">
        <p-table
            [autoLayout]="true"
            [value]="siteWorkers"
            [(selection)]="selectedWorkers"
            selectionMode="multiple"
            sortField="name"
        >
          <ng-template pTemplate="header">
              <tr>
                <th></th>
                <th>Name</th>
                <th>Username</th>
                <th>Company</th>
              </tr>
          </ng-template>
          <ng-template pTemplate="body" let-worker>
            <tr [pSelectableRow]="worker">
              <td><p-tableCheckbox [pSelectableRow]="worker" [value]="worker"></p-tableCheckbox></td>
              <td>{{ worker.workerUser.firstName }} {{ worker.workerUser.lastName }}</td>
              <td>{{ worker.workerUser.login }}</td>
              <td>{{ worker.workerUser.workerUser.maintenance.name }}</td>
            </tr>
          </ng-template>
          <ng-template pTemplate="emptymessage" let-columns>
            <tr>
              <td [attr.colspan]="8">No workers found for this site</td>
            </tr>
          </ng-template>
        </p-table>
      </div>
    </div>
    <div class="card-footer">
      <p-paginator #paginator [rows]="pagination.size" [totalRecords]="pagination.totalRecords" (onPageChange)="paginate($event)"></p-paginator>
    </div>
  </div>
  <p-footer>
    <button type="button" (click)="onSubmit()" class="btn btn-sm btn-success">Save</button>
    <button type="button" (click)="closeModal()" class="btn btn-sm btn-default">Cancel</button>
  </p-footer>
</div>
